module.exports = __webpack_public_path__ + "img/duck.8b93ff8.png";